import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=10938f9c&scoped=true&"
import script from "./Communication.vue?vue&type=script&lang=js&"
export * from "./Communication.vue?vue&type=script&lang=js&"
import style0 from "./Communication.vue?vue&type=style&index=0&id=10938f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10938f9c",
  null
  
)

export default component.exports